export default {
  title: {
    add: 'Adicionar Script',
    update: 'Atualizar Script',
  },
  form: {
    strategy: {
      label: 'Estratégia',
      placeholder: 'Selecionar Estratégia',
    },
    source: {
      label: 'Fonte (src)',
      placeholder: 'Inserir Fonte',
    },
    async: {
      label: 'Async',
      placeholder: 'Selecionar Async',
    },
    content: {
      label: 'Conteúdo',
      placeholder: 'Inserir Conteúdo',
    },
  },
  alert: {
    use_case: 'Caso de uso',
  },
  buttons: {
    save: 'Guardar',
  },
};
